/* eslint-disable max-len */
import { usersList } from "./apiSlice";

export const deviceTemplateList=usersList.injectEndpoints({
    tagTypes:['DeviceTemplate'],
    endpoints:(builder)=>({
        getDeviceTemplates: builder.query({
            query: (searchParams) => `devices/device-template?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'DeviceTemplate',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'DeviceTemplate', id:_id}))
            ]:[]
            
        }),
        // add device template journey
        addDeviceTemplate:builder.mutation({
            query:org=>({
                url:`devices/device-template`,
                method:'POST',
                body:org
            }),
            invalidatesTags:['DeviceTemplate']
        }),
        // view device template journey
        viewDeviceTemplate: builder.query({    
            query: (id) => `devices/device-template/${id}`,
            providesTags: (result, error, arg) => [{ type: 'DeviceTemplate', id: arg }]    
        }),
        // edit device template journey
        editDeviceTemplate:builder.mutation({
            query:({id,body})=>({
                url:id!==undefined?`/devices/device-template/${id}`:`/devices/device-template/`,
                method:'PATCH',
                body:body
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'DeviceTemplate', id: arg.id },'DeviceTemplate']
        }),
        exportDeviceTemplates:builder.mutation({
            query: ({ columns, dateformat, params }) => {
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return {
                    url: `devices/export-device-template?${queryParams}`,
                    method: 'POST',
                    body: { "columns": columns, "dateformat": dateformat ,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone }
                };
            },
        }),
        deleteDeviceTemplate:builder.mutation({
            query:(body)=>({
                url:`devices/device-template`,
                method:'DELETE',
                body:body,
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'DeviceTemplate', id: arg.id },'DeviceTemplate']
        })


    }),
    overrideExisting: false
})


export const {useGetDeviceTemplatesQuery,useAddDeviceTemplateMutation,useEditDeviceTemplateMutation, useViewDeviceTemplateQuery,useLazyViewDeviceTemplateQuery,useExportDeviceTemplatesMutation,useDeleteDeviceTemplateMutation}=deviceTemplateList